import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jobs-anaheim-hills',
  templateUrl: './jobs-anaheim-hills.component.html',
  styleUrls: ['./jobs-anaheim-hills.component.scss']
})
export class JobsAnaheimHillsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/jobs-anaheim-hills/jobs-anaheim-hills.component.ts